import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Actions as UnityEngineActions, WorkoutUnityResult } from 'web_unity_engine';
import type { IInitUnityPayload } from './types';

export interface IUnityState {
  // engine started flag
  started: boolean;
  // loading progress
  progress: number;
  // current exercise name
  exerciseName: string;
  // running gameplay
  running: boolean;
}

export const initialState: IUnityState = {
  started: false,
  progress: 0,
  exerciseName: '',
  running: false,
};

export const statePropName = 'unity';

const unitySlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initUnity: {
      reducer: (state, action: PayloadAction<IInitUnityPayload>) => {
        // No state change needed for init
      },
      prepare: (preloading?: boolean, basePath?: string) => ({
        payload: { preloading, basePath },
      }),
    },
    unityStarted: (state) => {
      state.started = true;
    },
    prepareExercise: (state, action: PayloadAction<string>) => {
      state.exerciseName = action.payload;
    },
    exerciseReady: (state) => {
      // No state change needed for exercise ready
    },
    startExercise: (state) => {
      state.running = true;
    },
    exerciseComplete: (state, action: PayloadAction<WorkoutUnityResult>) => {
      state.running = false;
    },
  },
  extraReducers(builder) {
    return builder.addCase(
      UnityEngineActions.unityProgressUpdate,
      (state, action: ReturnType<typeof UnityEngineActions.unityProgressUpdate>) => {
        state.progress = action.payload;
      }
    );
  },
});

export const UnityActions = unitySlice.actions;
export default unitySlice.reducer;
